export const environment = {
    useMocks: {
        vehicles: false,
        oem: false,
    },
    production: false,

    url: 'https://apim-eu-d-dtpa-01.azure-api.net/api',
};
